import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=03136852"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03136852')) {
      api.createRecord('03136852', component.options)
    } else {
      api.reload('03136852', component.options)
    }
    module.hot.accept("./ContactList.vue?vue&type=template&id=03136852", function () {
      api.rerender('03136852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/ContactList.vue"
export default component.exports